/** Month-grid helpers shared by the single picker and its range mode. */

export const WEEKDAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

export const startOfDay = (date: Date) => {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
};

export const isSameDay = (a: Date | null, b: Date | null) =>
  Boolean(a && b) && startOfDay(a as Date).getTime() === startOfDay(b as Date).getTime();

/** The month as a grid row-major from Sunday: blanks before the 1st, then each day. */
export const buildDayCells = (view: Date) => {
  const year = view.getFullYear();
  const month = view.getMonth();
  const offset = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  return [
    ...Array.from({ length: offset }, () => null),
    ...Array.from({ length: daysInMonth }, (_, index) => new Date(year, month, index + 1)),
  ];
};
